import $ from 'jquery';
import { mkToast } from '@shared/js/toasts.js';

import { v1BaseUrl } from '@shared/js/apiV1.js';

let reloadTriggered = false;

function triggerReload() {
  if (!reloadTriggered) {
    reloadTriggered = true;
    console.warn('Service Unavailable. Reloading the page.');
    location.reload();
  }
}

function setupFetchReloadOn503() {
  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    if (response && response.status === 503) {
      triggerReload();
    }
    return response;
  };
}

export const APP_VERSION = "2026.43.1";
// export const APP_BUILD = // get build from `build` key found in JSON response at `/v1/app/instance`

export function svInit() {
        // Log app version for debugging purposes
        console.info(`Stage Vault v${APP_VERSION} - Created by Devin Baeten`);

        setupFetchReloadOn503();

        // API Error Handling
        $(document).ajaxError(function(event, request, settings) {
                if (request.status === 503) {
                        triggerReload();
                        return;
                }

                const mode = settings?.svErrorMode || 'default';
                const whitelist = Array.isArray(settings?.svErrorWhitelist) ? settings.svErrorWhitelist : [];

                if (mode === 'none') {
                        return;
                }
                if (mode === 'custom' && whitelist.includes(request.status)) {
                        return;
                }

                // Ignore unauthorized errors on the login/sign up screen
                if (request.status === 401 && $("#authPrompt").length) {
                        return;
                }

                let errorMessage = "Unable to connect to the server.";
                if (request.status > 0) {
                        errorMessage = `Error ${request.status}: ${request.statusText}`;
                }

                mkToast("error", "danger", "Network Error", errorMessage, 5000);
        });
	
	// iCheck
	iCheck();
}

function iCheck() {
        // Persistent version and build check
        let currentVersion;
        let currentBuild;

        const checkVersion = () => {
               $.ajax({
                       url: v1BaseUrl + "app/instance",
                       type: 'GET',
                        svErrorMode: 'default',
                       success: (response) => {
                                if (currentVersion === undefined) {
                                        currentVersion = response.version;
                                        currentBuild = response.build;
                                } else if (response.build && response.build !== currentBuild) {
                                        currentBuild = response.build;
                                        location.reload();
                                // Exact-match, not ordered: date versions don't compare
                                // lexicographically (e.g. "2026.27.10" < "2026.27.2")
                                } else if (response.version !== currentVersion) {
                                        currentVersion = response.version;
                                        location.reload();
                                }
                        },
                        error: (error) => {
                                // Log failed version check for debugging
                                console.error(`Error: ${JSON.stringify(error)}`);
                        }
                });
        }

        checkVersion(); // Run once immediately
        // Skip background tabs — the next visible tick picks up any new build.
        setInterval(() => {
                if (!document.hidden) {
                        checkVersion();
                }
        }, 30000); // Then start interval
}
